import { Alert, Link, Typography } from '@mui/material';
import React from 'react';
import { useGetCurrentOrganization } from '../../../services/react-query/organization';
import usePermissionAllowed from '../../../hooks/usePermissionAllowed';
import { Actions } from '../../../services/react-query/permissions';
import AppLink from '../../common/AppLink/AppLink';

export default function SubscriptionAlert() {
  const { data: organization } = useGetCurrentOrganization({});

  const orgWritePermitted = usePermissionAllowed(Actions.ORGANIZATION_WRITE);
  const content = orgWritePermitted ?
    <Typography>Your subscription has been canceled. Please renew it <AppLink to="/organization">here</AppLink> to continue using Schedulinik.</Typography> :
    <Typography>Your subscription has been canceled. Please contact your administrator.</Typography>;

  if (organization?.subscription_status !== 'paused') return null;

  return (
    <Alert severity="error" sx={{ display: 'flex', justifyContent: 'center' }}>
      {content}
    </Alert>
  );
}